import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import Icon from '@ant-design/icons';
import { ReactComponent as HamburgerIconSvg } from '../../assets/hamburger-icon.svg';

export const HamburgerIcon = (props: Partial<CustomIconComponentProps>): JSX.Element => {
  return <Icon component={HamburgerIconSvg} {...props} />;
};
